import React from 'react'
import styled from 'styled-components';

const SignalHeader = styled.div`
position: relative;
width: 100%;
height: 200px;
background-image: url("/images/banner.jpg");
background-size: cover;
`;
const Overly = styled.div`
position: absolute;
width: 100%;
height: 100%;
background-color:#0c3245f0;
color: white;
display: flex;
justify-content: center;
align-items: center;
h2{
    font-size: 30px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
}
`;
export default function SingalHeader(props) {
    return (
        <>
            <SignalHeader>
                <Overly> <h2>{props.title}</h2> </Overly>
            </SignalHeader>
        </>
    )
}
